import type { SxProps, Theme } from "@mui/material/styles";

import type { FilterChipSize } from "./FilterChip.types";

export const root =
  (active: boolean, size: FilterChipSize): SxProps<Theme> =>
  (theme) => ({
    fontWeight: 700,
    cursor: "pointer",
    height: size === "sm" ? 24 : 40,
    fontSize: size === "sm" ? "0.625rem" : "0.8125rem",
    backgroundColor: active ? theme.palette.primary.light : theme.palette.divider,
    color: active ? theme.palette.common.white : theme.palette.text.secondary,
    border: "none",

    "&:hover": {
      backgroundColor: active ? theme.palette.primary.main : theme.palette.action.hover,
    },

    "& .MuiChip-icon": {
      color: active ? theme.palette.common.white : theme.palette.text.secondary,
    },
  });
